const $khttp = require('./khttp');
const $kstore = require('./kstore');
const userApiServer = "/kabala";
/**** 对外提供使用前缓存函数:getname/getloginid/isorg/isuser/isrole/getuser/getorg/getrole	****/
/**** 获取所有用户缓存函数:getallorg(仅包含name/uid/loginid) getalluser(仅包含name/uid) getallrole(仅包含name/uid)****/
/**** 非缓存函数:getchilduser/getchildrole/ getchildrole ****/
const $kuser={
	_putcache:function(userdatas,usertrees){
		//设置对象..
		var userobj={};
		var orgobj={};
		var roleobj={};
		var userorg={};
		for(i = 0,len=userdatas.length;i<len;i++){
			var item = userdatas[i];
			if(item.type==1){
				userobj[item.uid] = item;
			}else if(item.type==2){
				orgobj[item.uid] = item;
			}else if(item.type==3){
				roleobj[item.uid] = item;
			}
		}
		this._setDataObjToCache("kabala.utime",new Date().getTime());
		this._setDataObjToCache("kabala.org",orgobj);
		this._setDataObjToCache("kabala.user",userobj);
		this._setDataObjToCache("kabala.role",roleobj);
		var roots = [];
		for(var i = 0;i<usertrees.length;i++){
			if( usertrees[i].parentid==undefined || usertrees[i].parentid.length==0){
				roots.push(usertrees[i].uid);
			}
		}
		this._setDataObjToCache("kabala.uroot",roots);
	},
	_checkcache:function(){
		var reloadcache = function(){
			var alluserdatas = $khttp.postSync(userApiServer,{"op":"alluserdatas","removeprops":JSON.stringify(["thirtpart"])});
			var allusertrees = $khttp.postSync(userApiServer,{"op":"allusertrees"});
			$kuser._putcache(alluserdatas,allusertrees);
		}
		var utime = this._findDataByCache("kabala.utime");
		if( (typeof utime) =='undefined' || utime==undefined || utime==null || utime.length==0 || utime==0 ){
			reloadcache();
		}else{
			if(typeof utime !='undefined' && utime!=null && new Date().getTime()-parseInt(utime)<300*1000){
				//忽略
			}else{
				if(window.usercacheinit==true){
					return;
				}
				window.usercacheinit = true;//防止多次执行
				setTimeout(function(){
					reloadcache();
					window.usercacheinit = false;
				},10);
			}
		}
	},
	reset:function(){
		//重置缓存:
		this._setDataObjToCache("kabala.org",null);
		this._setDataObjToCache("kabala.user",null);
		this._setDataObjToCache("kabala.role",null);
		this._setDataObjToCache("kabala.utime",null);
		this._setDataObjToCache("kabala.uroot",null);
		this._setDataObjToCache("kabala.userheader",null);
	},
	_setDataObjToCache:function(cachename,datas){
		if(datas==null){
			$kstore.del(cachename);
		}else{
			$kstore.set(cachename,datas);
		}
	},
	_findDataByCache:function(cachename){
		return $kstore.get(cachename);
	},
	_findUidByCache:function(uid){
		this._checkcache();
		var cache = this._findDataByCache("kabala.user");
		if(cache && cache[uid]){
			return cache[uid];
		}
		var cache = this._findDataByCache("kabala.org");
		if(cache && cache[uid]){
			return cache[uid];
		}
		var cache = this._findDataByCache("kabala.role");
		if(cache && cache[uid]){
			return cache[uid];
		}
	},
	_string2Object:function(obj,key){
		if(typeof obj[key] == "string" ){
			obj[key] = JSON.parse(obj[key]);
		}
	},
	/****** 根据uiddata获取的数据 *****/
	getnames:function(uids){
		this._checkcache();
		var caches = $kstore.gets(["kabala.user","kabala.org","kabala.role"]);
		var caches_user = caches["kabala.user"];
		var caches_org = caches["kabala.org"];
		var caches_role = caches["kabala.role"];
		var result = {};
		for(var i = 0;i<uids.length;i++){
			var uid = uids[i];
			if(caches_user[uid]){
				result[uid] = caches_user[uid].name;

			}else if(caches_org[uid]){
				result[uid] = caches_org[uid].name;

			}if(caches_role[uid]){
				result[uid] = caches_role[uid].name;
			}
		}
		return result;
	},
	getname:function(uid){
		this._checkcache();
		var cache = this._findUidByCache(uid);
		if(cache && cache.name){
			return cache.name;
		}
		return "";
	},
	getloginid:function(uid){
		this._checkcache();
		var cache = this._findUidByCache(uid);
		if(cache && cache.loginid){
			return cache.loginid;
		}
		return "";
	},

	getalluser:function(){
		this._checkcache();
		var result =  this._findDataByCache("kabala.user");
		//注意此处返回的parentroles/parentorgs是字符串而非数组
		if(result){
			return result;
		}else{
			return [];
		}
	},
	getallorg:function(){
		this._checkcache();
		var result =  this._findDataByCache("kabala.org");
		//注意此处返回的parentroles/parentorgs是字符串而非数组
		if(result){
			return result;
		}else{
			return [];
		}

	},

	getallrole:function(){
		this._checkcache();
		var result =  this._findDataByCache("kabala.role");
		//注意此处返回的parentroles/parentorgs是字符串而非数组
		if(result){
			return result;
		}else{
			return [];
		}
	},
	getuser:function(uid){
		this._checkcache();
		var alldatas = $kuser.getalluser();
		if(alldatas && alldatas[uid]){
			return alldatas[uid];
		}
		return null;
	},
	getorg:function(uid){
		this._checkcache();
		var alldatas = $kuser.getallorg();
		if(alldatas && alldatas[uid]){
			return alldatas[uid];
		}
		return null;
	},
	getrole:function(uid){
		this._checkcache();
		var alldatas = $kuser.getallrole();
		if(alldatas && alldatas[uid]){
			return alldatas[uid];
		}
		return null;
	},

	isuser:function(uid){
		this._checkcache();
		var cache = this._findDataByCache("kabala.user");
		return cache && cache[uid];
	},
	isorg:function(uid){
		this._checkcache();
		var cache = this._findDataByCache("kabala.org");
		return cache && cache[uid];
	},
	isrole:function(uid){
		this._checkcache();
		var cache = this._findDataByCache("kabala.role");
		return cache && cache[uid];
	},

	getchilduser:function(uid){
		return $khttp.postSync("/kabala",{"op":"listsubuiddatas","parentid":uid,"hasuser":true,depth:1});
	},
	getchildorg:function(uid){
		if(uid==null || uid.length==0){
			this._checkcache();
			var usertrees = this._findDataByCache("kabala.uroot");

			var result = [];
			for(var i=0;i<usertrees.length;i++){
				var obj = $kuser.getorg(usertrees[i]);

				if(obj!=null){
					result.push(obj);
				}
			}
			return result;
		}else{
			return $khttp.postSync("/kabala",{"op":"listsubuiddatas","parentid":uid,"hasorg":true,depth:1});
		}
	},
	getchildrole:function(uid){
		if(uid==null || uid.length==0){
			this._checkcache();
			var usertrees = this._findDataByCache("kabala.uroot");

			var result = [];
			for(var i=0;i<usertrees.length;i++){
				var obj = $kuser.getrole(usertrees[i]);
				if(obj!=null){
					result.push(obj);
				}
			}
			return result;
		}
		return $khttp.postSync("/kabala",{"op":"listsubuiddatas","parentid":uid,"hasrole":true,depth:1});
	},
	/**
	 * 获取部门全路径,换行分隔 
	 * @param uid: String  部门ID
	 * @param orgs?: Array 路径数组
	 * @returns 
	 */
	 getorgfullpath:function(uid,orgs){
        try{
            if (!orgs) { orgs = []; }
            if($kuser.isorg(uid)){
                let org = $kuser.getorg(uid);
                let name = org.name;
                let temp = org.parentorgs;
                orgs.push(name)
                let porgs = JSON.parse(temp);
                if (porgs && porgs.length>0) {
                    return $kuser.getorgfullpath(porgs[0],orgs);
                }
            }else{
                return '';
            }
            return orgs.reverse().join("/");
        }catch(e){
            return '';
        }
	},
	sort:function(arr){
		arr.sort(function(a,b){
			if (a.sortnumber < b.sortnumber ) { //排前面
				return -1;
			}else if (a.sortnumber > b.sortnumber ) { //排后面
				return 1;
			}else{
				return 0;
			}
		});
		return arr;
	},
	/*** 以下是API函数 ****/
	newuid:function(parentid,name,type,loginid){
		$kuser.reset();
		return $khttp.postSync(userApiServer,{"op":"newuid","parentid":parentid,"name":name,"type":type,"loginid":loginid==undefined?"":loginid});
	},
	deleteuid:function(uid){
		$kuser.reset();
		return $khttp.postSync(userApiServer,{"op":"deleteuid","uid":uid});
	},
	setuidname:function(uid,name){
		$kuser.reset();
		return $khttp.postSync(userApiServer,{"op":"setuidname","uid":uid,"name":name});
	},
	setuidprops:function(uid,props){
		$kuser.reset();
		return $khttp.postSync(userApiServer,{"op":"setuidprops","uid":uid,"props":JSON.stringify(props)});
	},
	adduidparent:function(uid,parentid,removeallold){
		$kuser.reset();
		return $khttp.postSync(userApiServer,{"op":"adduidparent","uid":uid,"parentid":parentid,"removeallold":removeallold});
	},
	removeuidparent:function(uid,parentid){
		$kuser.reset();
		return $khttp.postSync(userApiServer,{"op":"removeuidparent","uid":uid,"parentid":parentid});
	},
	sortuid:function(parentid,uid,isup){
		$kuser.reset();
		return $khttp.postSync(userApiServer,{"op":"sortuid","parentid":parentid,"uid":uid,"isup":isup});
	}
}
module.exports = $kuser;
